import React from 'react';
import { InputAdornment, TextField, withStyles } from '@material-ui/core';
import styled from 'styled-components';

const StyledIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0;
  margin-left: 6px;
`;

const classes = {
  root: {
    fontWeight: 500,
    color: '#000'
  },
  input: {
    padding: '12px 6px !important',
    borderBottom: 'none',
    background: '#f5f5f5'
  },
  underline: {
    '&:before': {
      borderBottom: 'none !important'
    },
    '&:after': {
      borderBottom: 'none !important'
    }
  },
  rootOutlined: {
    border: '1px solid #cccccc',
    borderRadius: '8px',
    marginTop: '22px !important'
  },
  rootOutlinedError: {
    border: '1px solid #AF2930',
    borderRadius: '8px',
    marginTop: '22px !important'
  },
  outlinedSelectInput: {
    padding: '8.5px 12px !important',
    borderRadius: '8px',
    height: '1em'
  },
  outlinedInput: {
    padding: '10px 12px !important',
    borderRadius: '8px',
    height: '1em'
  },
  outlinedLabel: {
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '22px',
    lineHeight: '22px',
    color: '#B9B9B9'
  },
  outlinedLabelError: {
    fontWeight: 500,
    fontSize: '14px',
    marginBottom: '22px',
    color: '#AF2930 !important',
    lineHeight: '22px'
  },
  outlinedRootHelperText: {
    marginTop: '4px'
  },
  adornedStart: {
    background: '#f5f5f5'
  },
  adornedEnd: {
    cursor: 'pointer'
  },
  fakeDisabled: {
    color: 'rgba(0, 0, 0, 0.87)',
    opacity: 0.6
  },
  fakeDisabledLabel: {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  fakeDisabledHelperText: {
    color: 'green'
  }
};

const getStyleProps = (variant, classes, Icon = null, iconPosition = 'start', iconHandler = null, isSelect = false) => {
  if (variant === 'filled') {
    return {
      InputLabelProps: {
        shrink: true
      },
      InputProps: {
        startAdornment: Icon ? (
          <InputAdornment position="start">
            <StyledIcon>
              <Icon onClick={iconHandler ? iconHandler() : undefined} />
            </StyledIcon>
          </InputAdornment>
        ) : null,
        classes: {
          adornedStart: classes.adornedStart,
          root: classes.root,
          input: classes.input,
          underline: classes.underline
        }
      },
      classes: {
        root: classes.root
      }
    };
  }

  if (variant === 'outlined' || variant === 'outlined_error') {
    return {
      InputLabelProps: {
        shrink: true,
        classes: {
          root: variant === 'outlined_error' ? classes.outlinedLabelError : classes.outlinedLabel
        }
      },
      FormHelperTextProps: {
        style: { minHeight: '32px', marginTop: '4px', paddingLeft: '12px' }
      },
      InputProps: {
        startAdornment:
          Icon && iconPosition === 'start' ? (
            <InputAdornment position="start">
              <StyledIcon>
                <Icon onClick={iconHandler ? iconHandler : undefined} />
              </StyledIcon>
            </InputAdornment>
          ) : null,
        endAdornment:
          Icon && iconPosition === 'end' ? (
            <InputAdornment
              onClick={iconHandler ? iconHandler : undefined}
              classes={{ root: classes.adornedEnd }}
              position="start"
            >
              <StyledIcon>
                <Icon />
              </StyledIcon>
            </InputAdornment>
          ) : null,
        classes: {
          root: variant === 'outlined_error' ? classes.rootOutlinedError : classes.rootOutlined,
          input: isSelect ? classes.outlinedSelectInput : classes.outlinedInput,
          underline: classes.underline
        }
      }
    };
  }

  if (variant === 'fake_disabled') {
    return {
      InputProps: {
        classes: {
          disabled: classes.fakeDisabled
        }
      },
      FormHelperTextProps: {
        style: { color: '#f44336' }
      },
      InputLabelProps: {
        classes: {
          disabled: classes.fakeDisabledLabel
        }
      }
    };
  }

  return {};
};

const FormTextField = ({
  input,
  label = '',
  meta: { touched, error, submitError, invalid },
  customError,
  classes,
  styleVariant,
  Icon,
  iconOptions = { position: 'start', handler: null },
  includeBottomIndent = false,
  inputRef = undefined,
  ...custom
}) => {
  const styleProps = getStyleProps(
    styleVariant,
    classes,
    Icon,
    iconOptions.position,
    iconOptions.handler,
    custom.select
  );

  return (
    <TextField
      innerRef={inputRef}
      error={(touched && invalid) || !!customError}
      placeholder={label}
      label={label}
      helperText={(touched && invalid && (submitError || error)) || customError || (includeBottomIndent ? ' ' : '')}
      {...styleProps}
      {...input}
      {...custom}
    />
  );
};

export default withStyles(classes)(FormTextField);

/* Search_Input_Field */
